import { modalCodeStore } from '@/store'
import { modalCodeParameterInterface } from '@/store/ModalCodeStore'

export class ModalCodeService {
  public open(params: modalCodeParameterInterface) {
    modalCodeStore.open(params)
  }

  public close() {
    modalCodeStore.close()
  }
}
